<template>
  <div>
    <reg-base-header-sec></reg-base-header-sec>

    <div class="container-fluid base-container ">
      <div class="base-box base-box__accordion-sec d-block d-md-flex">
        <div
          class="accordion   NotPrintableArea"
          role="tablist"
          :class="{ 'acc-sidebar': isActOpen, 'flex-fill': !isActOpen }"
        >
          <b-card
            no-body
            v-for="(item_cat, cat_index) in itemList"
            v-bind:key="item_cat.id"
            class="ac_card"
          >
            <b-card-header
              header-tag="header"
              class="ac_card-header"
              role="tab"
            >
              <b-button
                class="btn btn-block accordion-title-btn ac_level_1-title-btn gray-title-accordian"
                variant="none"
                block
                href="#"
                v-b-toggle="'accordion-' + item_cat.id"
              >
                <span class="accordion-title-btn__text">{{
                  item_cat.name
                }}</span>
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'accordion-' + item_cat.id"
              :visible11="isCollapseVisible(cat_index)"
              class="ac_collapse scroll_to_collapse"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body class="p-0">
                <div class="ac_collapse__item-list">
                  <b-card
                    no-body
                    v-for="item in item_cat.children"
                    v-bind:key="item.id"
                    class="ac_card"
                  >
                    <b-card-header
                      header-tag="header"
                      class="ac_card-header-level-2"
                      role="tab"
                    >
                      <b-button
                        class="btn btn-block accordion-title-btn-level-2 btn-none "
                        variant="none"
                        block
                        href="#"
                        v-b-toggle="'accordion-' + item.id"
                      >
                        <span class="text-not-bold">{{ item.name }}</span>
                      </b-button>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + item.id"
                      class="ac_collapse scroll_to_collapse"
                      :accordion="'accordion-' + item_cat.id"
                      role="tabpanel"
                    >
                      <ul class="ac_collapse__item-list-level-2">
                        <li
                          v-for="sub_item in item.children"
                          v-bind:key="sub_item.id"
                          class="ac_collapse__item"
                        >
                          <div v-if="sub_item.children.length > 0" class="">
                            <a
                              v-on:click="openCollapse(sub_item.id)"
                              class="ac_collapse__link-level-2 accordion-item-link italic-active"
                              :class="{
                                active: selectedItemId === sub_item.id,
                              }"
                              href="#"
                              v-b-toggle="'accordion-' + sub_item.id"
                            >
                              <span>{{ sub_item.name }}</span>
                            </a>
                            <b-collapse
                              :id="'accordion-' + sub_item.id"
                              class="ac_collapse scroll_to_collapse"
                              :accordion="'accordion-' + item.id"
                              role="tabpanel"
                            >
                              <ul
                                class="ac_collapse__item-list-level-3 collapse-level-3"
                              >
                                <li
                                  class="ac_collapse__item "
                                  v-for="sub_sub_item in sub_item.children"
                                  v-bind:key="sub_sub_item.id"
                                >
                                  <a
                                    v-on:click.stop="
                                      openAct(
                                        sub_sub_item.id,
                                        sub_sub_item.name
                                      )
                                    "
                                    :class="{
                                      active:
                                        selectedItemId === sub_sub_item.id,
                                    }"
                                    class="ac_collapse__link-level-2 accordion-item-link collapse-level-3__link italic-active"
                                    href="#"
                                  >
                                    {{ sub_sub_item.name }}
                                  </a>
                                </li>
                              </ul>
                            </b-collapse>
                          </div>
                          <a
                            v-else
                            v-on:click.stop="
                              openAct(sub_item.id, sub_item.name)
                            "
                            :class="{ active: selectedItemId === sub_item.id }"
                            class="ac_collapse__link-level-2 accordion-item-link italic-active"
                            href="#"
                          >
                            {{ sub_item.name }}
                          </a>
                        </li>
                      </ul>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div v-if="isActOpen" class="p-3 p-md-5 flex-fill" id="openedActsId">
          <div id="html_to_printing" class="printing">
            <div class=" only-print text-center mb-4">
              <h4 class="print-title">
                ПРАВНО ИНФОРМАЦИОНИ СИСТЕМ Републике Србије <br />
                РЕГИСТАР И ТЕКСТОВИ ВАЖЕЋИХ ПРОПИСА И ДРУГИХ АКАТА
              </h4>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <h2 class="sadrzaj-naslov-span">{{ actHeading }}</h2>
              <button
                class="btn btn-primary NotPrintableArea"
                @click="print2()"
              >
                <span class="icon-printer"></span>
              </button>
            </div>
            <HtmlDiv
              v-html="actHTML"
              class="printableArea"
              style="font-family: Open Sans,sans-serif !important;
                            color: #333 !important;
                            position: relative !important;
                            font-style: normal !important;
                            font-size: 100%  !important;"
            ></HtmlDiv>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import RegBaseHeaderSec from "@/base_pages/reg/RegBaseHeaderSec.vue";
import HtmlDiv from "@/components/HtmlDiv.vue";
window.$ = window.jQuery = require("jquery");
// import VueHtmlToPaper from 'vue-html-to-paper';

export default {
  name: "RegOverviewPage",
  data() {
    return {
      itemNameIsClick: false,
      selectedItemId: null,
      isActOpen: false,
      actHeading: "",
      actHTML: "",
      itemList: [],
      baseApiUrl: window.env.VUE_APP_API_REG_DEV,
      baseDiApiUrl: window.env.VUE_APP_API_DI_DEV,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  components: {
    RegBaseHeaderSec,
    HtmlDiv,
  },
  methods: {
    itemNameClick(id) {
      this.itemNameIsClick = id;
    },
    print2() {
      // Pass the element id here
      window.print("html_to_printing");
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("html_to_printing");
    },
    openCollapse(id) {
      this.selectedItemId = id;
    },
    buildLink(uuid, match) {
      axios.get(this.baseApiUrl + "meta/byActUuid/" + uuid).then((response) => {
        if (response.data.url !== undefined) {
          // this.actHTML = this.actHTML.replace(match, 'href="' + this.baseUrl + response.data.url.substr(1) + '?q=' + uuid + '"');
          this.actHTML = this.actHTML.replace(
            match,
            'href="' +
              this.baseApiUrl +
              response.data.url.substr(1) +
              "/" +
              "reg" +
              '"'
          );
        } else
          this.actHTML = this.actHTML.replace(
            match,
            'href="' + this.baseApiUrl + "viewAct/naziv-akta/" + uuid + '"'
          );
      });
    },
    openAct(actId, actHeading) {
      //http://10.10.32.183/viewAct/naziv-akta/10482
      this.selectedItemId = null;
      this.selectedItemId = actId;
      axios
        .get(this.baseDiApiUrl + "REG/GetRegActs?areaId=" + actId)
        .then((response) => {
          var re = /ui-sref="[^(]+\({[^}]+\}\)"/g;

          var matches = response.data.match(re);
          var data = response.data;

          if (matches) {
            for (var i = 0; i < matches.length; i++) {
              var param = matches[i].substring(29, 65);
              data = data.replace(
                matches[i],
                'href="' + this.baseApiUrl + "viewAct/" + param + '"'
              );
            }
          }

          this.actHTML = data;
        });

      this.isActOpen = true;
      this.actHeading = actHeading;

      window.innerWidth < 992 &&
        this.$nextTick(() => {
          setTimeout(() => {
            const element = document.getElementById("openedActsId");
            element && element.scrollIntoView({ behavior: "smooth" });
          }, 80);
        });
    },
    fetchData() {
      axios.get(this.baseApiUrl + "menu").then((response) => {
        // console.log(response);
        // console.log(response);
        this.itemList = response.data;
      });
    },
    isCollapseVisible(cat_index) {
      return cat_index === 0;
    },
  },
  created() {
    // Fetch Data
    this.fetchData();
  },
  beforeCreate: function() {
    document.body.className = "color_reg";
  },
};
</script>

<style>
.main {
  background-color: #ddd !important;
  padding-bottom: 360px !important;
}

/* .printableArea table tr td:first-child {
    width: 20px !important;
} */

.sadrzajRight1 {
  font-size: 16px !important;
}

.main .sadrzajHier1 {
  font-size: 16px !important;
  width: 28px !important;
}

.sadrzajDiv1 .sadrzajLink,
.sadrzajDiv1 .sadrzajMiddle,
.sadrzajDiv2 .sadrzajLink,
.sadrzajDiv3 .sadrzajLink,
.sadrzajDiv4 .sadrzajLink {
  font-size: 14px !important;
}

.sadrzajLink:visited {
  color: #187d03 !important;
}
.sadrzajLink {
  color: #007000 !important;
  font-family: Arial, sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 0;
  text-decoration: underline !important;
  cursor: pointer;
}

.color_reg .base-text-color,
.color_reg .color-link,
.color_reg table td a,
.color_reg table th a {
  color: #187d03 !important;
}

.sadrzajLink:hover {
  color: #609060 !important;
}

.cssKlasa {
  background: #fff !important;
}

.sadrzajLink_visited {
  color: olive !important;
  font-family: Arial, sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 0 !important;
  text-decoration: underline !important;
}

.sadrzajMiddle,
.sadrzajRight {
  font-weight: 400 !important;
  display: inline !important;
  font-family: Open Sans, sans-serif !important;
}

.apstrakt {
  overflow: auto;
  max-height: 80px;
  min-width: 500px;
}

.sadrzajApstrakt {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 2px 0 !important;
  font-style: normal !important;
  text-align: left !important;
  font-size: 10px !important;
  overflow-wrap: anywhere;
}

.sadrzajNadNaslov1,
.sadrzajPodNaslov {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 2px 0 !important;
  font-style: italic !important;
  text-align: left !important;
  font-size: 10px !important;
  overflow-wrap: anywhere;
}

.sadrzajDiv1 {
  background: none repeat scroll 0 0 #f4f6f9 !important;
  padding: 5px !important;
  text-align: left !important;
}

.sadrzajHier1 {
  vertical-align: top !important;
  padding-top: 4px !important;
  width: 4% !important;
}

.sadrzajLink1 {
  color: green !important;
  font-family: Arial, sans-serif !important;
  font-size: 12px !important;
  padding: 0 !important;
}

.sadrzajLink1,
.sadrzajMiddle1 {
  font-weight: 700 !important;
}

.sadrzajRight1 {
  font-weight: 400 !important;
  font-style: italic !important;
}

.sadrzajApstrakt1 {
  padding: 2px 0 2px 28px !important;
  font-size: 11px !important;
}

.sadrzajApstrakt1,
.sadrzajPodNaslov1 {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  font-style: italic !important;
  text-align: left !important;
  overflow-wrap: anywhere;
}

.sadrzajPodNaslov1 {
  padding: 2px 0 !important;
  font-size: 10px !important;
}

.sadrzajNadNaslov2 {
  color: #000 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 2px 0 2px 32px !important;
  font-style: normal !important;
  text-align: left !important;
  font-size: 12px !important;
  overflow-wrap: anywhere;
}

.sadrzajDiv2 {
  background: none repeat scroll 0 0 #fff !important;
  padding: 5px !important;
  text-align: left !important;
}

.sadrzajHier2 {
  padding-left: 20px !important;
}

.sadrzajHier2,
.sadrzajHier3 {
  vertical-align: top !important;
  width: 4% !important;
  padding-top: 4px !important;
}

.sadrzajHier3 {
  padding-left: 42px !important;
}

.sadrzajTableRegistar .sadrzajHier4 {
  padding-left: 64px !important;
  padding-top: 4px !important;
  vertical-align: top !important;
  width: 4% !important;
}

.sadrzajLink2 {
  color: green !important;
  font-family: Arial, sans-serif !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 0 !important;
}

.sadrzajMiddle2,
.sadrzajRight2 {
  font-weight: 400 !important;
}

.sadrzajRight2 {
  font-style: italic !important;
}

.sadrzajApstrakt2 {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  padding: 2px 0 2px 48px !important;
  font-style: italic !important;
  text-align: left !important;
  font-size: 11px !important;
  overflow-wrap: anywhere;
}

.sadrzajRight3 {
  font-weight: 400 !important;
  font-style: italic !important;
}

.sadrzajApstrakt3 {
  padding: 2px 0 2px 82px !important;
  font-style: italic !important;
}

.sadrzajApstrakt3,
.sadrzajPodNaslov2 {
  color: #484848 !important;
  font-family: Arial, Helvetica, sans-serif !important;
  text-align: left !important;
  font-size: 11px !important;
  overflow-wrap: anywhere;
}

.sadrzajPodNaslov2 {
  padding: 2px 0 2px 20px !important;
}

.sadrzajRight4 {
  font-weight: 400 !important;
  font-style: italic !important;
}
@media print {
  .NotPrintableArea,
  #lz_overlay_chat {
    display: none !important;
  }
}
</style>
